import React, { Component } from 'react';
import SVipAccessFlow from 'shared/screens/VipAccessFlow';
import './VipAccessFlow.scss';
import Utils from 'shared/utils/index';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import CopySelector from 'shared/utils/copySelector';

const hasVIPPass = playNow => {
  return (
    <div className="vipAccessContainer">
      <div className={'vipAccessInfo' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <div className="hasVipAccess">
          <img src={require(asset`images/Promotional_Graphics/Promotional_Graphic@3x.png`)} alt="VIP Access" />
        </div>
        <p className="vipAccessSubtitle">
          <img alt="" src={require(asset`Light_Divider@3x.png`)} />
          {getText(TEXT_KEY.ALREADY_HAVE_VIP_ACCESS)} {CopySelector.getCopy(CopySelector.COPY_TYPES.VIP)}{' '}
          {getText(TEXT_KEY.ROOM)}
        </p>
      </div>
      <div className={'vipAccessButtons' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <div className="vipAccessButton" onClick={playNow}>
          <img alt="Play button" src={require(asset`images/VIP_Assets/Play_Now_Button@3x.png`)} />
        </div>
      </div>
    </div>
  );
};

const VIPAccessNeeded = (purchaseVipAccess, redeemVipAccess, enterRequirements) => {
  return (
    <div className="vipAccessContainer">
      <span className="vipAccessTitle">
        {CopySelector.getCopy(CopySelector.COPY_TYPES.VIP)} {getText(TEXT_KEY.VIP_ACCESS_NEEDED)}
      </span>
      <div className={'vipAccessInfo' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <p className="vipAccessSubtitle">
          <img alt="" src={require(asset`Light_Divider@3x.png`)} />
          {getText(TEXT_KEY.CAN_ACCESS_VIP_ROOM)} {CopySelector.getCopy(CopySelector.COPY_TYPES.VIP)}{' '}
          {getText(TEXT_KEY.ROOM_IN_FOLLOWING_WAYS)}
        </p>
        <div className="vipAccessSteps">
          {ENVIRONMENT_VARIABLES.DYNAMIC_HIGHLIMIT_POPUP &&
          ENVIRONMENT_VARIABLES.DYNAMIC_HIGHLIMIT_POPUP.toString() === 'true' ? (
            enterRequirements.map(requirement => (
              <div>
                <img src={requirement.icon} alt="VIP Access options" />
              </div>
            ))
          ) : (
            <img src={require(asset`images/VIP_Assets/Access_Options@3x.png`)} alt="VIP Access options" />
          )}
        </div>
      </div>
      <div className={'vipAccessButtons' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}>
        <div className="vipAccessButton" onClick={purchaseVipAccess}>
          <img alt="Purchase button" src={require(asset`images/VIP_Assets/Purchase_Button@3x.png`)} />
        </div>
        <div className="vipAccessButton" onClick={redeemVipAccess}>
          <img alt="Redeem button" src={require(asset`images/VIP_Assets/Redeem_Button@3x.png`)} />
        </div>
      </div>
    </div>
  );
};

export default class VipAccessFlow extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-vip-access',
    };
  }

  render() {
    return (
      <SVipAccessFlow
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const { purchaseVipAccess, redeemVipAccess, playNow, isVipRoomUnlocked, enterRequirements } = args;
          return (
            <div>
              {isVipRoomUnlocked
                ? hasVIPPass(playNow)
                : VIPAccessNeeded(purchaseVipAccess, redeemVipAccess, enterRequirements)}
            </div>
          );
        }}
      />
    );
  }
}

